var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("HeaderControls", {
        ref: "refHeaderControls",
        attrs: {
          myWeek: false,
          parentDeliverableId: _vm.parentDeliverableId,
          namespace: _vm.namespace,
          tabTitle: "content-calendar",
          pageCount: _vm.pageCount,
          showCreatedPostedDateSort: _vm.isListAllView,
          showLogo: true
        },
        on: {
          filterUpdated: _vm.filterUpdate,
          collapseToggleUpdated: _vm.collapseToggleUpdate,
          showEditDeliverableModal: _vm.showEditDeliverableModal
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "deliverable-main container-fluid" }, [
        _c(
          "div",
          {
            staticClass: "deliverable-listing social-media-grouped",
            class: {
              hasFilter:
                _vm.filterQuery.status.length ||
                _vm.filterQuery.coordinator.length ||
                _vm.filterQuery.tag.length ||
                _vm.filterQuery.outlet.length
            }
          },
          [
            _c(
              "b-modal",
              {
                attrs: {
                  centered: "",
                  "hide-footer": "",
                  id: "viewTitleModal",
                  title: "Enter View Title"
                }
              },
              [
                _c("ViewTitleModal", {
                  ref: "refViewTitleModal",
                  attrs: { namespace: _vm.namespace },
                  on: { setActiveView: _vm.setActiveView }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  centered: "",
                  "hide-footer": "",
                  id: "viewTitleUpdateModal",
                  title: "Enter View Title"
                }
              },
              [
                _c("ViewTitleModal", {
                  ref: "refViewTitleModal",
                  attrs: {
                    title: _vm.viewBtnLabel,
                    viewId: _vm.activeView,
                    namespace: _vm.namespace
                  },
                  on: { setActiveView: _vm.setActiveView }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                staticClass: "modal-edit-social-deliverable",
                attrs: {
                  size: "lg",
                  "hide-footer": "",
                  id: "editSocialModal",
                  title: "Edit Social Deliverable",
                  "no-close-on-backdrop": "",
                  "no-close-on-esc": ""
                },
                on: {
                  show: _vm.editSocialModalShown,
                  shown: _vm.afterEditSocialModalShown,
                  hide: _vm.editSocialModalHidden
                }
              },
              [
                _c("EditSocialModal", {
                  ref: "refEditSocialModal",
                  attrs: {
                    allContacts: _vm.allContacts,
                    tabIndex: _vm.tabIndex,
                    namespace: _vm.namespace
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                staticClass: "modal-edit-deliverable",
                attrs: {
                  size: "xl",
                  "no-close-on-backdrop": "",
                  "no-close-on-esc": "",
                  "hide-footer": "",
                  id: "editOrganicSocialMediaPlanModal",
                  title: "Edit Organic Social Media Plan"
                },
                on: { hide: _vm.editOrganicSocialModalPlanHidden }
              },
              [
                _c("EditOrganicSocialMediaPlanModal", {
                  ref: "refEditOrganicSocialMediaPlanModal",
                  attrs: { tabIndex: _vm.tabIndex, namespace: _vm.namespace }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "deleteDeliverableConfirmModal",
                  type: "warn",
                  title: "Confirm Deletion",
                  "ok-title": "Yes, Delete"
                },
                on: {
                  ok: _vm.onConfirmRemoveDeliverable,
                  cancel: _vm.onCancelRemoveDeliverable
                }
              },
              [
                _c("p", [
                  _vm._v("Are you sure you want to delete this deliverable?")
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                staticClass: "modal-edit-social-campaign",
                attrs: {
                  size: "lg",
                  "hide-footer": "",
                  id: "editSocialCampaignModal",
                  title: "Edit Social Campaign"
                }
              },
              [
                _c("SocialCampaignDialog", {
                  ref: "refSocialCampaignDialogModal",
                  attrs: { namespace: _vm.namespace },
                  on: { socialCampaignClose: _vm.createCampaignClose }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "deliverable-header" }, [
              _c(
                "div",
                { staticClass: "header-title-tabs-row" },
                [
                  _c("HeaderIcon", {
                    attrs: {
                      totalDeliverableCount: this.allDeliverablesPaginationData
                        .total
                        ? this.allDeliverablesPaginationData.total
                        : 0,
                      totalOutletCount: this.outletCount ? this.outletCount : 0,
                      totalDeliverableCountNoMasters: this
                        .deliverableTotalMinusMasters,
                      myWeek: false,
                      isListView: this.isListView,
                      namespace: _vm.namespace
                    }
                  }),
                  _vm._v(" "),
                  _c("SocialTabs")
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "deliverable-block-wrap" },
              [
                _c("HorizontalMonthPicker", {
                  attrs: {
                    namespace: _vm.namespace,
                    parentDeliverableId: _vm.parentDeliverableId
                  }
                }),
                _vm._v(" "),
                false
                  ? _c(
                      "div",
                      { staticClass: "deliverable-group-views-wrapper" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "d-inline-block float-right saved-views-area",
                            class: [
                              !_vm.showUpdateViewText ? "pt-15" : "",
                              _vm.activeView != "-1" ? "saved-view-active" : ""
                            ]
                          },
                          [
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showUpdateViewText,
                                    expression: "showUpdateViewText"
                                  }
                                ],
                                staticClass: "text-right"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: { click: _vm.directUpdateView }
                                  },
                                  [_vm._v("Click here")]
                                ),
                                _vm._v(" to save updated view\n\t\t\t\t\t")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "btn-group float-right add-new__global_search sorting saved-views"
                              },
                              [
                                !_vm.showCreateNewView
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-theme ml-2 header-filter-btns dropdown-toggle",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        },
                                        on: { click: _vm.updatePerfectScroll }
                                      },
                                      [
                                        _vm.showUpdateViewText
                                          ? _c("span", {
                                              staticClass: "updated-view"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "mr-3 view__label truncate-text"
                                          },
                                          [_vm._v(_vm._s(_vm.viewBtnLabel))]
                                        ),
                                        _vm._v(" "),
                                        _vm.activeView == "-1"
                                          ? _c("i", {
                                              staticClass:
                                                "fas fa-fw fa-eye text-primary float-right"
                                            })
                                          : _c("i", {
                                              directives: [
                                                {
                                                  name: "b-tooltip",
                                                  rawName: "v-b-tooltip.hover",
                                                  value: {
                                                    customClass:
                                                      "save__view__tooltip"
                                                  },
                                                  expression:
                                                    "{customClass: 'save__view__tooltip'}",
                                                  modifiers: { hover: true }
                                                }
                                              ],
                                              staticClass:
                                                "fas fa-fw fa-eye text-primary float-right",
                                              attrs: { title: "Clear View" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleResetFilter()
                                                }
                                              }
                                            })
                                      ]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-theme ml-2 header-filter-btns dropdown-toggle save__new__view",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-haspopup": "true",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _vm.showUpdateViewText
                                          ? _c("span", {
                                              staticClass: "updated-view"
                                            })
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "mr-3 view__label" },
                                          [_vm._v("Views")]
                                        ),
                                        _vm._v(" "),
                                        _c("i", {
                                          directives: [
                                            {
                                              name: "b-tooltip",
                                              rawName: "v-b-tooltip.hover",
                                              value: {
                                                customClass:
                                                  "save__view__tooltip"
                                              },
                                              expression:
                                                "{ customClass: 'save__view__tooltip' }",
                                              modifiers: { hover: true }
                                            }
                                          ],
                                          staticClass:
                                            "fas fa-fw fa-eye text-primary float-right",
                                          attrs: { title: "Save View" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.saveView.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu viewmenu-dropdown"
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item update-view",
                                            attrs: { href: "#" },
                                            on: { click: _vm.updateView }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\tUpdate View\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _vm._m(0)
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "dropdown-item save-view",
                                            attrs: { href: "#" },
                                            on: { click: _vm.saveView }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\tSave View\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                            _vm._m(1)
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "perfect-scrollbar",
                                          {
                                            ref: "views__scroll",
                                            staticClass: "views__scroll"
                                          },
                                          [
                                            _c(
                                              "div",
                                              [
                                                _vm._l(
                                                  _vm.presetViewsDashboard,
                                                  function(userView, index) {
                                                    return _c(
                                                      "a",
                                                      {
                                                        key:
                                                          "userView" +
                                                          index +
                                                          1 * Math.random(),
                                                        staticClass:
                                                          "dropdown-item",
                                                        class: {
                                                          active:
                                                            _vm.activeView ==
                                                            userView.id
                                                        },
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.loadView(
                                                              userView,
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("div", {
                                                          staticClass:
                                                            "preset-icon-wrap"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "save-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                userView.title
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  _vm.userViewsDeliverable,
                                                  function(userView, index) {
                                                    return _c(
                                                      "a",
                                                      {
                                                        key:
                                                          "userView" +
                                                          index +
                                                          1 * Math.random(),
                                                        staticClass:
                                                          "dropdown-item",
                                                        class: {
                                                          active:
                                                            _vm.activeView ==
                                                            userView.id
                                                        },
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.loadView(
                                                              userView,
                                                              index
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "remove-icon-wrap"
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "remove-icon",
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.removeView(
                                                                      userView.id
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _c("i", {
                                                                  staticClass:
                                                                    "fas fa-trash"
                                                                })
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "save-title"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                userView.title
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        false
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "d-inline-block float-right pt-15 mr-3 expand-all-area"
                              },
                              [
                                _vm.$router.currentRoute.name !=
                                  "globalSearch" &&
                                _vm.$router.currentRoute.name != "calendar"
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "ml-2 expand-grp cursor-pointer",
                                        on: {
                                          click: function($event) {
                                            return _vm.toggleExpandAll(
                                              !_vm.expandAll
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass:
                                              "header-filter-btns expand-ctrls",
                                            class: {
                                              "none-active-btn": _vm.expandAll
                                            },
                                            attrs: {
                                              variant: "theme",
                                              title: "Expand"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text" },
                                              [_vm._v("Expand All ")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "icon" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas text-primary fa-expand fa-fw"
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "b-tooltip",
                                                rawName: "v-b-tooltip.hover",
                                                modifiers: { hover: true }
                                              }
                                            ],
                                            staticClass:
                                              "header-filter-btns expand-ctrls",
                                            class: {
                                              "none-active-btn": !_vm.expandAll
                                            },
                                            attrs: {
                                              variant: "theme",
                                              title: "Collapse"
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "text" },
                                              [_vm._v("Collapse All")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "icon" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas text-primary fa-compress fa-fw"
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        false
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-inline-block float-right saved-views-area pt-15"
                              },
                              [
                                _c("div", { staticClass: "text-right" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-by-wrap dropdown" },
                                    [
                                      _vm._m(2),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-menu" },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                to: {
                                                  name: "socialMedia",
                                                  params: {
                                                    socialGroupBy: "socialMedia"
                                                  }
                                                }
                                              }
                                            },
                                            [_vm._v("Dates")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "router-link",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: {
                                                to: {
                                                  name: "socialMediaGrouped",
                                                  params: {
                                                    socialGroupBy:
                                                      "socialMediaGrouped"
                                                  }
                                                }
                                              }
                                            },
                                            [_vm._v("Campaign/Series")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getSystemSetting(
                          "social_media___show_new_campaign_button"
                        ) ||
                        _vm.getSystemSetting(
                          "social_media___show_new_social_series_button"
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-inline-block float-right saved-views-area pt-15 mr-2"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "new-social-group-container dropdown"
                                  },
                                  [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dropdown-menu" },
                                      [
                                        _vm.getSystemSetting(
                                          "social_media___show_new_campaign_button"
                                        )
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                attrs: { href: "#" },
                                                on: {
                                                  click: _vm.createCampaignClick
                                                }
                                              },
                                              [_vm._v("Campaign")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.getSystemSetting(
                                          "social_media___show_new_social_series_button"
                                        )
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "dropdown-item",
                                                attrs: { href: "#" },
                                                on: {
                                                  click: _vm.createSeriesClick
                                                }
                                              },
                                              [_vm._v("Series")]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getSystemSetting(
                          "social_media___enable_post_import"
                        )
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "d-inline-block float-right saved-views-area pt-15 mr-2"
                              },
                              [
                                _c("div", { staticClass: "text-right" }, [
                                  _c(
                                    "div",
                                    { staticClass: "group-by-wrap dropdown" },
                                    [
                                      _vm._m(4),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "dropdown-menu" },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass: "dropdown-item",
                                              attrs: { href: "#" },
                                              on: {
                                                click:
                                                  _vm.exportSocialMediaExcel
                                              }
                                            },
                                            [_vm._v("Download Excel")]
                                          ),
                                          _vm._v(" "),
                                          _vm.getSystemSetting(
                                            "social_media___enable_post_import"
                                          )
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass: "dropdown-item",
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click:
                                                      _vm.importSocialMediaExcel
                                                  }
                                                },
                                                [_vm._v("Import Posts")]
                                              )
                                            : _vm._e()
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isListAllView
                  ? [
                      _c("SocialMediaListAll", {
                        attrs: {
                          selectedDeliverable: _vm.selectedDeliverable,
                          listView: true,
                          calendarOnly: false,
                          hasSocialCampaign: false,
                          hasSocialSeries: false,
                          socialCampaignId: null,
                          socialSeriesId: null,
                          filterQuery: _vm.socialMediaFilter,
                          myWeek: false,
                          expandAll: _vm.expandAll,
                          parentDeliverableId: null,
                          namespace: _vm.namespace,
                          showNewPostButton: "true",
                          pageCount: _vm.pageCount
                        },
                        on: {
                          collapseToggleUpdated: _vm.collapseToggleUpdate,
                          showEditDeliverableModal:
                            _vm.showEditDeliverableModal,
                          deleteSocialMediaDeliverable:
                            _vm.deleteDeliverableClick,
                          duplicateDeliverable: _vm.duplicateDeliverable
                        }
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isListView
                  ? [
                      _c("SocialGroupedByDate", {
                        attrs: {
                          selectedDeliverable: _vm.selectedDeliverable,
                          listView: true,
                          calendarOnly: false,
                          hasSocialCampaign: false,
                          hasSocialSeries: false,
                          socialCampaignId: null,
                          socialSeriesId: null,
                          filterQuery: _vm.filterQuery,
                          myWeek: false,
                          expandAll: _vm.expandAll,
                          namespace: _vm.namespace
                        },
                        on: {
                          collapseToggleUpdated: _vm.collapseToggleUpdate,
                          showEditDeliverableModal:
                            _vm.showEditDeliverableModal,
                          deleteSocialMediaDeliverable:
                            _vm.deleteSocialMediaDeliverable
                        }
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isListView && !_vm.isListAllView
                  ? [
                      _c("SocialGrouped", {
                        attrs: {
                          selectedDeliverable: _vm.selectedDeliverable,
                          calendarOnly: true,
                          hasSocialCampaign: false,
                          hasSocialSeries: false,
                          socialCampaignId: null,
                          socialSeriesId: null,
                          filterQuery: _vm.filterQuery,
                          myWeek: false,
                          expandAll: _vm.expandAll,
                          namespace: _vm.namespace
                        },
                        on: {
                          collapseToggleUpdated: _vm.collapseToggleUpdate,
                          showEditDeliverableModal:
                            _vm.showEditDeliverableModal,
                          deleteSocialMediaDeliverable:
                            _vm.deleteSocialMediaDeliverable
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.listSocialCampaigns, function(
                        campaign,
                        campaign_idx
                      ) {
                        return _c(
                          "div",
                          { key: "campaign" + campaign_idx },
                          [
                            _c("SocialGrouped", {
                              attrs: {
                                selectedDeliverable: _vm.selectedDeliverable,
                                calendarOnly: false,
                                hasSocialCampaign: true,
                                hasSocialSeries: false,
                                socialCampaignId: campaign.id,
                                socialCampaignName: campaign.title,
                                socialSeriesId: null,
                                socialSeriesName: null,
                                filterQuery: _vm.filterQuery,
                                myWeek: false,
                                expandAll: _vm.expandAll,
                                listCount: campaign.list_count,
                                totalCount: campaign.total_count,
                                namespace: _vm.namespace
                              },
                              on: {
                                collapseToggleUpdated: _vm.collapseToggleUpdate,
                                showEditDeliverableModal:
                                  _vm.showEditDeliverableModal,
                                deleteSocialMediaDeliverable:
                                  _vm.deleteSocialMediaDeliverable
                              }
                            }),
                            _vm._v(" "),
                            _vm._l(
                              _vm.getListSocialSeriesWithSocialCampaign(
                                campaign.id
                              ),
                              function(series, series_idx) {
                                return series_idx != "totalOutlets"
                                  ? _c(
                                      "div",
                                      { key: "campaignseries" + series_idx },
                                      [
                                        _c("SocialGrouped", {
                                          attrs: {
                                            selectedDeliverable:
                                              _vm.selectedDeliverable,
                                            calendarOnly: false,
                                            hasSocialCampaign: true,
                                            hasSocialSeries: true,
                                            socialCampaignId: campaign.id,
                                            socialCampaignName: campaign.title,
                                            socialSeriesId: series.id,
                                            masterDeliverableId:
                                              series.master_deliverable_id,
                                            socialSeriesName: series.title,
                                            filterQuery: _vm.filterQuery,
                                            myWeek: false,
                                            expandAll: _vm.expandAll,
                                            listCount: series.list_count,
                                            totalCount: series.total_count,
                                            namespace: _vm.namespace
                                          },
                                          on: {
                                            collapseToggleUpdated:
                                              _vm.collapseToggleUpdate,
                                            showEditDeliverableModal:
                                              _vm.showEditDeliverableModal,
                                            deleteSocialMediaDeliverable:
                                              _vm.deleteSocialMediaDeliverable
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              }
                            )
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _vm._l(
                        _vm.getListSocialSeriesWithoutSocialCampaign(),
                        function(series, series_index) {
                          return _c(
                            "div",
                            { key: "seriesAlone-" + series_index },
                            [
                              _c("SocialGrouped", {
                                attrs: {
                                  selectedDeliverable: _vm.selectedDeliverable,
                                  calendarOnly: false,
                                  hasSocialCampaign: false,
                                  hasSocialSeries: true,
                                  socialCampaignId: null,
                                  socialSeriesId: series.id,
                                  socialSeriesName: series.title,
                                  masterDeliverableId:
                                    series.master_deliverable_id,
                                  filterQuery: _vm.filterQuery,
                                  myWeek: false,
                                  expandAll: _vm.expandAll,
                                  listCount: series.list_count,
                                  totalCount: series.total_count,
                                  namespace: _vm.namespace
                                },
                                on: {
                                  collapseToggleUpdated:
                                    _vm.collapseToggleUpdate,
                                  showEditDeliverableModal:
                                    _vm.showEditDeliverableModal,
                                  deleteSocialMediaDeliverable:
                                    _vm.deleteSocialMediaDeliverable
                                }
                              })
                            ],
                            1
                          )
                        }
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "far fa-edit text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "float-right" }, [
      _c("i", { staticClass: "fas fa-plus-circle text-primary" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme header-filter-btns",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _vm._v("List by "),
        _c("i", {
          staticClass: "fas text-primary float-right fa-chevron-down fa-fw"
        })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme header-filter-btns",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _vm._v("New "),
        _c("i", { staticClass: "fas text-primary float-right fa-plus fa-fw" })
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn-theme header-filter-btns",
        attrs: { type: "button", "data-toggle": "dropdown" }
      },
      [
        _vm._v("Export/Import"),
        _c("i", {
          staticClass: "fas text-primary float-right fa-chevron-down fa-fw"
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }